<template>
  <ContentWrap title="OTA渠道管理">
    <el-tabs v-model="activeTab" @tab-change="handleTabChange">
      <!-- Tab1: 渠道管理 -->
      <el-tab-pane label="渠道管理" name="channel">
        <el-form :model="channelQueryParams" ref="channelQueryFormRef" :inline="true" label-width="68px" class="-mb-15px">
          <el-form-item label="渠道编码" prop="channelCode">
            <el-select
              v-model="channelQueryParams.channelCode"
              placeholder="请选择渠道"
              clearable
              class="!w-180px"
            >
              <el-option label="美团" value="MEITUAN" />
              <el-option label="去哪儿" value="QUNAR" />
              <el-option label="携程" value="CTRIP" />
              <el-option label="飞猪" value="FLIGGY" />
            </el-select>
          </el-form-item>
          <el-form-item label="渠道名称" prop="channelName">
            <el-input
              v-model="channelQueryParams.channelName"
              placeholder="请输入名称"
              clearable
              class="!w-180px"
              @keyup.enter="getChannelList"
            />
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="channelQueryParams.status"
              placeholder="请选择状态"
              clearable
              class="!w-140px"
            >
              <el-option label="启用" :value="0" />
              <el-option label="禁用" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="getChannelList"><Icon icon="ep:search" class="mr-5px" /> 搜索</el-button>
            <el-button @click="resetChannelQuery"><Icon icon="ep:refresh" class="mr-5px" /> 重置</el-button>
            <el-button
              type="primary"
              plain
              @click="openChannelForm('create')"
              v-hasPermi="['hotel:ota:create']"
            >
              <Icon icon="ep:plus" class="mr-5px" /> 新增渠道
            </el-button>
          </el-form-item>
        </el-form>

        <el-table v-loading="channelLoading" :data="channelList" :stripe="true">
          <el-table-column label="渠道编码" align="center" prop="channelCode" width="100">
            <template #default="scope">
              <el-tag>{{ getChannelCodeLabel(scope.row.channelCode) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="渠道名称" align="center" prop="channelName" min-width="120" />
      <el-table-column label="API地址" align="center" prop="apiUrl" min-width="180">
        <template #default="scope">
          <span>{{ scope.row.apiUrl || '-' }}</span>
        </template>
      </el-table-column>
          <el-table-column label="AppId" align="center" prop="appId" width="140">
            <template #default="scope">
              <span>{{ scope.row.appId || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="同步状态" align="center" prop="syncStatus" width="100">
            <template #default="scope">
              <el-tag :type="getSyncStatusTag(scope.row.syncStatus)">
                {{ getSyncStatusLabel(scope.row.syncStatus) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" prop="status" width="80">
            <template #default="scope">
              <el-tag :type="scope.row.status === 0 ? 'success' : 'info'">
                {{ scope.row.status === 0 ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" prop="createTime" width="160">
            <template #default="scope">
              <span>{{ scope.row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160">
            <template #default="scope">
              <el-button
                link
                type="primary"
                @click="openChannelForm('update', scope.row.id)"
                v-hasPermi="['hotel:ota:update']"
              >
                编辑
              </el-button>
              <el-button
                link
                type="danger"
                @click="handleChannelDelete(scope.row.id)"
                v-hasPermi="['hotel:ota:delete']"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          :total="channelTotal"
          v-model:page="channelQueryParams.pageNo"
          v-model:limit="channelQueryParams.pageSize"
          @pagination="getChannelList"
        />
      </el-tab-pane>

      <!-- Tab2: 房型映射 -->
      <el-tab-pane label="房型映射" name="roomMapping">
        <el-form :model="mappingQueryParams" ref="mappingQueryFormRef" :inline="true" label-width="68px" class="-mb-15px">
          <el-form-item label="店铺" prop="shopId">
            <el-select
              v-model="mappingQueryParams.shopId"
              placeholder="请选择店铺"
              clearable
              class="!w-180px"
            >
              <el-option
                v-for="shop in shopList"
                :key="shop.id"
                :label="shop.name"
                :value="shop.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="getMappingList"><Icon icon="ep:search" class="mr-5px" /> 搜索</el-button>
            <el-button @click="resetMappingQuery"><Icon icon="ep:refresh" class="mr-5px" /> 重置</el-button>
            <el-button
              type="primary"
              plain
              @click="openMappingForm('create')"
              v-hasPermi="['hotel:ota-room-mapping:create']"
            >
              <Icon icon="ep:plus" class="mr-5px" /> 新增映射
            </el-button>
          </el-form-item>
        </el-form>

        <el-table v-loading="mappingLoading" :data="mappingList" :stripe="true">
          <el-table-column label="店铺" align="center" min-width="120">
            <template #default="scope">
              <el-tag v-if="scope.row.shopName" type="info">{{ scope.row.shopName }}</el-tag>
              <span v-else class="text-gray-400">-</span>
            </template>
          </el-table-column>
          <el-table-column label="房型" align="center" min-width="120">
            <template #default="scope">
              <el-tag v-if="scope.row.spuName" type="info">{{ scope.row.spuName }}</el-tag>
              <span v-else class="text-gray-400">-</span>
            </template>
          </el-table-column>
          <el-table-column label="OTA渠道" align="center" prop="otaChannelName" width="120">
            <template #default="scope">{{ scope.row.otaChannelName || '-' }}</template>
          </el-table-column>
          <el-table-column label="OTA房型编码" align="center" prop="otaRoomTypeCode" width="140" />
          <el-table-column label="OTA房型名称" align="center" prop="otaRoomTypeName" min-width="140" />
          <el-table-column label="操作" align="center" width="160">
            <template #default="scope">
              <el-button
                link
                type="primary"
                @click="openMappingForm('update', scope.row.id)"
                v-hasPermi="['hotel:ota-room-mapping:update']"
              >
                编辑
              </el-button>
              <el-button
                link
                type="danger"
                @click="handleMappingDelete(scope.row.id)"
                v-hasPermi="['hotel:ota-room-mapping:delete']"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          :total="mappingTotal"
          v-model:page="mappingQueryParams.pageNo"
          v-model:limit="mappingQueryParams.pageSize"
          @pagination="getMappingList"
        />
      </el-tab-pane>

      <!-- Tab3: 价格策略 -->
      <el-tab-pane label="价格策略" name="priceStrategy">
        <el-form :model="strategyQueryParams" ref="strategyQueryFormRef" :inline="true" label-width="68px" class="-mb-15px">
          <el-form-item label="店铺" prop="shopId">
            <el-select
              v-model="strategyQueryParams.shopId"
              placeholder="请选择店铺"
              clearable
              class="!w-180px"
            >
              <el-option
                v-for="shop in shopList"
                :key="shop.id"
                :label="shop.name"
                :value="shop.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="房型" prop="spuId">
            <el-select
              v-model="strategyQueryParams.spuId"
              placeholder="请选择房型"
              clearable
              class="!w-180px"
            >
              <el-option
                v-for="spu in spuList"
                :key="spu.id"
                :label="spu.name"
                :value="spu.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="getStrategyList"><Icon icon="ep:search" class="mr-5px" /> 搜索</el-button>
            <el-button @click="resetStrategyQuery"><Icon icon="ep:refresh" class="mr-5px" /> 重置</el-button>
            <el-button
              type="primary"
              plain
              @click="openStrategyForm('create')"
              v-hasPermi="['hotel:ota-price-strategy:create']"
            >
              <Icon icon="ep:plus" class="mr-5px" /> 新增策略
            </el-button>
          </el-form-item>
        </el-form>

        <el-table v-loading="strategyLoading" :data="strategyList" :stripe="true">
          <el-table-column label="店铺" align="center" min-width="120">
            <template #default="scope">
              <el-tag v-if="scope.row.shopName" type="info">{{ scope.row.shopName }}</el-tag>
              <span v-else class="text-gray-400">-</span>
            </template>
          </el-table-column>
          <el-table-column label="房型" align="center" min-width="120">
            <template #default="scope">
              <el-tag v-if="scope.row.spuName" type="info">{{ scope.row.spuName }}</el-tag>
              <span v-else class="text-gray-400">-</span>
            </template>
          </el-table-column>
          <el-table-column label="OTA渠道" align="center" prop="otaChannelName" width="120">
            <template #default="scope">{{ scope.row.otaChannelName || '-' }}</template>
          </el-table-column>
          <el-table-column label="调整类型" align="center" prop="adjustType" width="120">
            <template #default="scope">
              <el-tag :type="scope.row.adjustType === 0 ? 'primary' : 'warning'">
                {{ scope.row.adjustType === 0 ? '固定金额' : '百分比' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="调整值" align="center" prop="adjustValue" width="120">
            <template #default="scope">
              <span v-if="scope.row.adjustType === 1">{{ scope.row.adjustValue }}%</span>
              <span v-else>{{ scope.row.adjustValue }}</span>
            </template>
          </el-table-column>
          <el-table-column label="最低价格" align="center" prop="minPrice" width="120">
            <template #default="scope">
              <span>{{ scope.row.minPrice != null ? '¥' + scope.row.minPrice : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="最高价格" align="center" prop="maxPrice" width="120">
            <template #default="scope">
              <span>{{ scope.row.maxPrice != null ? '¥' + scope.row.maxPrice : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160">
            <template #default="scope">
              <el-button
                link
                type="primary"
                @click="openStrategyForm('update', scope.row.id)"
                v-hasPermi="['hotel:ota-price-strategy:update']"
              >
                编辑
              </el-button>
              <el-button
                link
                type="danger"
                @click="handleStrategyDelete(scope.row.id)"
                v-hasPermi="['hotel:ota-price-strategy:delete']"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          :total="strategyTotal"
          v-model:page="strategyQueryParams.pageNo"
          v-model:limit="strategyQueryParams.pageSize"
          @pagination="getStrategyList"
        />
      </el-tab-pane>
    </el-tabs>
  </ContentWrap>

  <!-- 渠道表单弹窗 -->
  <Dialog :title="channelDialogTitle" v-model="channelDialogVisible" width="550px">
    <el-form ref="channelFormRef" :model="channelFormData" :rules="channelFormRules" label-width="100px" v-loading="channelFormLoading">
      <el-form-item label="渠道编码" prop="channelCode">
        <el-select v-model="channelFormData.channelCode" placeholder="请选择渠道" class="!w-1/1" :disabled="channelFormType === 'update'">
          <el-option label="美团" value="MEITUAN" />
          <el-option label="去哪儿" value="QUNAR" />
          <el-option label="携程" value="CTRIP" />
          <el-option label="飞猪" value="FLIGGY" />
        </el-select>
      </el-form-item>
      <el-form-item label="渠道名称" prop="channelName">
        <el-input v-model="channelFormData.channelName" placeholder="请输入渠道名称" />
      </el-form-item>
      <el-form-item label="API地址" prop="apiUrl">
        <el-input v-model="channelFormData.apiUrl" placeholder="请输入API地址" />
      </el-form-item>
      <el-form-item label="AppId" prop="appId">
        <el-input v-model="channelFormData.appId" placeholder="请输入AppId" />
      </el-form-item>
      <el-form-item label="AppSecret" prop="appSecret">
        <el-input v-model="channelFormData.appSecret" type="password" show-password placeholder="请输入AppSecret" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="submitChannelForm" type="primary" :disabled="channelFormLoading">确 定</el-button>
      <el-button @click="channelDialogVisible = false">取 消</el-button>
    </template>
  </Dialog>

  <!-- 房型映射表单弹窗 -->
  <Dialog :title="mappingDialogTitle" v-model="mappingDialogVisible" width="550px">
    <el-form ref="mappingFormRef" :model="mappingFormData" :rules="mappingFormRules" label-width="120px" v-loading="mappingFormLoading">
      <el-form-item label="店铺" prop="shopId">
        <el-select
          v-model="mappingFormData.shopId"
          placeholder="请选择店铺"
          clearable
          filterable
          class="!w-1/1"
        >
          <el-option
            v-for="shop in shopList"
            :key="shop.id"
            :label="shop.name"
            :value="shop.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="房型" prop="spuId">
        <el-select
          v-model="mappingFormData.spuId"
          placeholder="请选择房型"
          clearable
          filterable
          class="!w-1/1"
        >
          <el-option
            v-for="spu in spuList"
            :key="spu.id"
            :label="spu.name"
            :value="spu.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="OTA渠道" prop="otaChannelId">
        <el-select v-model="mappingFormData.otaChannelId" placeholder="请选择渠道" class="!w-1/1">
          <el-option
            v-for="channel in channelList"
            :key="channel.id"
            :label="channel.channelName"
            :value="channel.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="OTA房型编码" prop="otaRoomTypeCode">
        <el-input v-model="mappingFormData.otaRoomTypeCode" placeholder="请输入OTA房型编码" />
      </el-form-item>
      <el-form-item label="OTA房型名称" prop="otaRoomTypeName">
        <el-input v-model="mappingFormData.otaRoomTypeName" placeholder="请输入OTA房型名称" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="submitMappingForm" type="primary" :disabled="mappingFormLoading">确 定</el-button>
      <el-button @click="mappingDialogVisible = false">取 消</el-button>
    </template>
  </Dialog>

  <!-- 价格策略表单弹窗 -->
  <Dialog :title="strategyDialogTitle" v-model="strategyDialogVisible" width="550px">
    <el-form ref="strategyFormRef" :model="strategyFormData" :rules="strategyFormRules" label-width="100px" v-loading="strategyFormLoading">
      <el-form-item label="店铺" prop="shopId">
        <el-select
          v-model="strategyFormData.shopId"
          placeholder="请选择店铺"
          clearable
          filterable
          class="!w-1/1"
        >
          <el-option
            v-for="shop in shopList"
            :key="shop.id"
            :label="shop.name"
            :value="shop.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="房型" prop="spuId">
        <el-select
          v-model="strategyFormData.spuId"
          placeholder="请选择房型"
          clearable
          filterable
          class="!w-1/1"
        >
          <el-option
            v-for="spu in spuList"
            :key="spu.id"
            :label="spu.name"
            :value="spu.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="OTA渠道" prop="otaChannelId">
        <el-select v-model="strategyFormData.otaChannelId" placeholder="请选择渠道" class="!w-1/1">
          <el-option
            v-for="channel in channelList"
            :key="channel.id"
            :label="channel.channelName"
            :value="channel.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="调整类型" prop="adjustType">
        <el-radio-group v-model="strategyFormData.adjustType">
          <el-radio :value="0">固定金额</el-radio>
          <el-radio :value="1">百分比</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="调整值" prop="adjustValue">
        <el-input-number v-model="strategyFormData.adjustValue" :min="0" :precision="2" class="!w-1/1" placeholder="请输入调整值" />
      </el-form-item>
      <el-form-item label="最低价格" prop="minPrice">
        <el-input-number v-model="strategyFormData.minPrice" :min="0" :precision="2" class="!w-1/1" placeholder="请输入最低价格(可选)" />
      </el-form-item>
      <el-form-item label="最高价格" prop="maxPrice">
        <el-input-number v-model="strategyFormData.maxPrice" :min="0" :precision="2" class="!w-1/1" placeholder="请输入最高价格(可选)" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="submitStrategyForm" type="primary" :disabled="strategyFormLoading">确 定</el-button>
      <el-button @click="strategyDialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import * as otaApi from '@/api/hotel/ota'
import { getShopSimpleList } from '@/api/hotel/platformShop'
import { getSpuSimpleList } from '@/api/mall/product/spu'

defineOptions({ name: 'HotelOta' })

const message = useMessage()

const activeTab = ref('channel')
const shopList = ref<{ id: string | number; name: string }[]>([])
const spuList = ref<{ id: string | number; name: string }[]>([])

const fetchDropdownData = async () => {
  try {
    const [shopRes, spuRes] = await Promise.all([
      getShopSimpleList(),
      getSpuSimpleList()
    ])
    shopList.value = shopRes || []
    spuList.value = spuRes || []
  } catch {
    // 静默处理
  }
}

// ============ 渠道管理 ============
const channelLoading = ref(true)
const channelList = ref<otaApi.OtaChannelVO[]>([])
const channelTotal = ref(0)
const channelQueryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  channelCode: undefined,
  channelName: undefined,
  status: undefined
})
const channelQueryFormRef = ref()

const channelCodeMap: Record<string, string> = {
  MEITUAN: '美团',
  QUNAR: '去哪儿',
  CTRIP: '携程',
  FLIGGY: '飞猪'
}
const getChannelCodeLabel = (code: string) => channelCodeMap[code] || code

const syncStatusMap: Record<number, string> = { 0: '未同步', 1: '同步中', 2: '已同步', 3: '同步失败' }
const syncStatusTagMap: Record<number, string> = { 0: 'info', 1: 'warning', 2: 'success', 3: 'danger' }
const getSyncStatusLabel = (s: number) => syncStatusMap[s] || '未知'
const getSyncStatusTag = (s: number) => syncStatusTagMap[s] || 'info'

const getChannelList = async () => {
  channelLoading.value = true
  try {
    const data = await otaApi.getChannelPage(channelQueryParams)
    channelList.value = data.list
    channelTotal.value = data.total
  } finally {
    channelLoading.value = false
  }
}

const resetChannelQuery = () => {
  channelQueryFormRef.value?.resetFields()
  channelQueryParams.pageNo = 1
  getChannelList()
}

// 渠道弹窗
const channelDialogVisible = ref(false)
const channelDialogTitle = ref('')
const channelFormLoading = ref(false)
const channelFormType = ref('')
const channelFormRef = ref()
const channelFormData = ref({
  id: undefined,
  channelCode: '',
  channelName: '',
  apiUrl: '',
  appId: '',
  appSecret: ''
})
const channelFormRules = reactive({
  channelCode: [{ required: true, message: '请选择渠道编码', trigger: 'change' }],
  channelName: [{ required: true, message: '请输入渠道名称', trigger: 'blur' }]
})

const openChannelForm = async (type: string, id?: string | number) => {
  channelDialogVisible.value = true
  channelDialogTitle.value = type === 'create' ? '新增渠道' : '编辑渠道'
  channelFormType.value = type
  channelFormData.value = {
    id: undefined,
    channelCode: '',
    channelName: '',
    apiUrl: '',
    appId: '',
    appSecret: ''
  }
  channelFormRef.value?.resetFields()
  if (id) {
    channelFormLoading.value = true
    try {
      const data = await otaApi.getChannel(id)
      channelFormData.value = { ...data }
    } finally {
      channelFormLoading.value = false
    }
  }
}

const submitChannelForm = async () => {
  await channelFormRef.value.validate()
  channelFormLoading.value = true
  try {
    const data = { ...channelFormData.value } as any
    if (channelFormType.value === 'create') {
      await otaApi.createChannel(data)
      message.success('新增成功')
    } else {
      await otaApi.updateChannel(data)
      message.success('修改成功')
    }
    channelDialogVisible.value = false
    await getChannelList()
  } finally {
    channelFormLoading.value = false
  }
}

const handleChannelDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await otaApi.deleteChannel(id)
    message.success('删除成功')
    await getChannelList()
  } catch {}
}

// ============ 房型映射 ============
const mappingLoading = ref(true)
const mappingList = ref<otaApi.OtaRoomMappingVO[]>([])
const mappingTotal = ref(0)
const mappingQueryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  shopId: undefined
})
const mappingQueryFormRef = ref()

const getMappingList = async () => {
  mappingLoading.value = true
  try {
    const data = await otaApi.getRoomMappingPage(mappingQueryParams)
    mappingList.value = data?.list || []
    mappingTotal.value = data?.total || 0
  } finally {
    mappingLoading.value = false
  }
}

const resetMappingQuery = () => {
  mappingQueryFormRef.value?.resetFields()
  mappingQueryParams.pageNo = 1
  getMappingList()
}

const mappingDialogVisible = ref(false)
const mappingDialogTitle = ref('')
const mappingFormLoading = ref(false)
const mappingFormType = ref('')
const mappingFormRef = ref()
const mappingFormData = ref({
  id: undefined,
  shopId: undefined,
  spuId: undefined,
  otaChannelId: undefined,
  otaRoomTypeCode: '',
  otaRoomTypeName: '',
  status: 0
})
const mappingFormRules = reactive({
  shopId: [{ required: true, message: '请选择店铺', trigger: 'change' }],
  spuId: [{ required: true, message: '请选择房型', trigger: 'change' }],
  otaChannelId: [{ required: true, message: '请选择OTA渠道', trigger: 'change' }],
  otaRoomTypeCode: [{ required: true, message: '请输入OTA房型编码', trigger: 'blur' }],
  otaRoomTypeName: [{ required: true, message: '请输入OTA房型名称', trigger: 'blur' }]
})

const openMappingForm = async (type: string, id?: string | number) => {
  mappingDialogVisible.value = true
  mappingDialogTitle.value = type === 'create' ? '新增房型映射' : '编辑房型映射'
  mappingFormType.value = type
  mappingFormData.value = {
    id: undefined,
    shopId: undefined,
    spuId: undefined,
    otaChannelId: undefined,
    otaRoomTypeCode: '',
    otaRoomTypeName: '',
    status: 0
  }
  mappingFormRef.value?.resetFields()
  if (id) {
    mappingFormLoading.value = true
    try {
      const data = await otaApi.getRoomMapping(id)
      mappingFormData.value = { ...data }
    } finally {
      mappingFormLoading.value = false
    }
  }
}

const submitMappingForm = async () => {
  await mappingFormRef.value.validate()
  mappingFormLoading.value = true
  try {
    const data = { ...mappingFormData.value } as any
    if (mappingFormType.value === 'create') {
      await otaApi.createRoomMapping(data)
      message.success('新增成功')
    } else {
      await otaApi.updateRoomMapping(data)
      message.success('修改成功')
    }
    mappingDialogVisible.value = false
    await getMappingList()
  } finally {
    mappingFormLoading.value = false
  }
}

const handleMappingDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await otaApi.deleteRoomMapping(id)
    message.success('删除成功')
    await getMappingList()
  } catch {}
}

// ============ 价格策略 ============
const strategyLoading = ref(true)
const strategyList = ref<otaApi.OtaPriceStrategyVO[]>([])
const strategyTotal = ref(0)
const strategyQueryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  shopId: undefined,
  spuId: undefined
})
const strategyQueryFormRef = ref()

const getStrategyList = async () => {
  strategyLoading.value = true
  try {
    const data = await otaApi.getPriceStrategyPage(strategyQueryParams)
    strategyList.value = data?.list || []
    strategyTotal.value = data?.total || 0
  } finally {
    strategyLoading.value = false
  }
}

const resetStrategyQuery = () => {
  strategyQueryFormRef.value?.resetFields()
  strategyQueryParams.pageNo = 1
  getStrategyList()
}

const strategyDialogVisible = ref(false)
const strategyDialogTitle = ref('')
const strategyFormLoading = ref(false)
const strategyFormType = ref('')
const strategyFormRef = ref()
const strategyFormData = ref({
  id: undefined,
  shopId: undefined,
  spuId: undefined,
  otaChannelId: undefined,
  adjustType: 0,
  adjustValue: 0,
  minPrice: undefined,
  maxPrice: undefined,
  status: 0
})
const strategyFormRules = reactive({
  shopId: [{ required: true, message: '请选择店铺', trigger: 'change' }],
  spuId: [{ required: true, message: '请选择房型', trigger: 'change' }],
  otaChannelId: [{ required: true, message: '请选择OTA渠道', trigger: 'change' }],
  adjustType: [{ required: true, message: '请选择调整类型', trigger: 'change' }],
  adjustValue: [{ required: true, message: '请输入调整值', trigger: 'blur' }]
})

const openStrategyForm = async (type: string, id?: string | number) => {
  strategyDialogVisible.value = true
  strategyDialogTitle.value = type === 'create' ? '新增价格策略' : '编辑价格策略'
  strategyFormType.value = type
  strategyFormData.value = {
    id: undefined,
    shopId: undefined,
    spuId: undefined,
    otaChannelId: undefined,
    adjustType: 0,
    adjustValue: 0,
    minPrice: undefined,
    maxPrice: undefined,
    status: 0
  }
  strategyFormRef.value?.resetFields()
  if (id) {
    strategyFormLoading.value = true
    try {
      const data = await otaApi.getPriceStrategy(id)
      strategyFormData.value = { ...data }
    } finally {
      strategyFormLoading.value = false
    }
  }
}

const submitStrategyForm = async () => {
  await strategyFormRef.value.validate()
  strategyFormLoading.value = true
  try {
    const data = { ...strategyFormData.value } as any
    if (strategyFormType.value === 'create') {
      await otaApi.createPriceStrategy(data)
      message.success('新增成功')
    } else {
      await otaApi.updatePriceStrategy(data)
      message.success('修改成功')
    }
    strategyDialogVisible.value = false
    await getStrategyList()
  } finally {
    strategyFormLoading.value = false
  }
}

const handleStrategyDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await otaApi.deletePriceStrategy(id)
    message.success('删除成功')
    await getStrategyList()
  } catch {}
}

// Tab切换
const handleTabChange = (tabName: string) => {
  if (tabName === 'channel') getChannelList()
  else if (tabName === 'roomMapping') getMappingList()
  else if (tabName === 'priceStrategy') getStrategyList()
}

onMounted(() => {
  fetchDropdownData()
  getChannelList()
})
</script>
